import { render, staticRenderFns } from "./AtomLabelRequired.vue?vue&type=template&id=0b308d5a&scoped=true&"
import script from "./AtomLabelRequired.vue?vue&type=script&lang=ts&"
export * from "./AtomLabelRequired.vue?vue&type=script&lang=ts&"
import style0 from "./AtomLabelRequired.vue?vue&type=style&index=0&id=0b308d5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b308d5a",
  null
  
)

export default component.exports